import Delegate from './delegate'
import SpeakerState from '../enums/speaker-state'

export default class Speaker {
  constructor () {
    this.id = null
    this.delegate = null
    this.opinion = null
    this.order = null
    this.status = null
    this.added = null
    this.spoken = null
  }

  static fromJson (json, opinion = null) {
    let speaker = new this()
    if (json.id !== null) {
      speaker.id = parseInt(json.id)
    }
    if (json.opinion !== null) {
      speaker.opinion = json.opinion
    }
    speaker.delegate = Delegate.fromJson(json.delegate)
    if (json.order !== null) {
      speaker.order = parseInt(json.order)
    }
    if (json.added !== null) {
      speaker.added = json.added
    }
    if (json.spoken !== null) {
      speaker.spoken = json.spoken === '1'
    }
    if (json.status !== null) {
      speaker.status = json.status
    }
    return speaker
  }

  isActive () {
    return this.status === SpeakerState.ACTIVE
  }
}



// WEBPACK FOOTER //
// ./src/models/speaker.js